import { progressEpic } from "epics/base-epic";
import { UPLOAD_BUYERS } from "constants/action-types";
import siteConfig from "site-config";
import { IUploadBuyersRequestAction, IUploadBuyersResponse } from "actions/upload-buyers-actions";
import { IUploadBuyersPayload } from "reducers/upload-buyers-reducer";

export const uploadBuyersEpic = progressEpic<IUploadBuyersRequestAction, IUploadBuyersPayload>(
    UPLOAD_BUYERS.UPLOAD,
    ({ payload }) => ({
        method: "POST",
        url: siteConfig.api + payload.url,
        body: payload.body,
        headers: {
            "X-Requested-With": "XMLHttpRequest",
            module: "default",
            Accept: "application/json",
        },
    }),
    {
        // @ts-ignore
        dataCustomizer: (response: IUploadBuyersResponse) => ({
            errors: response.errors,
            message: response.localizedMessage,
        }),
        checkErrorStatus: ({ xhr }) => {
            throw Error(xhr.response?.localizedMessage);
        },
    },
);
